import { Box, TextPreset } from '@facile-it/full-metal-ui/components'
import { NextPage } from 'next'
import Head from 'next/head'
import * as React from 'react'
import { Container, HeroCaption, HeroContainer, HeroContent, HeroTitle } from '../components'
import { AppLink } from '../components/routing/AppLink'
import * as styles from '../styles/Pages.css'

const ServizioReclami: NextPage = () => (
    <>
        <Head>
            <title>Servizio reclami | Saturno assicurazioni</title>
        </Head>
        <HeroContainer
            hasBackground
            variant="small-one"
            paddingX={{ mobile: 'none', desktop: 'l' }}
            paddingBottom={{ mobile: 'l', desktop: 'none' }}
        >
            <HeroContent>
                <HeroTitle>Servizio Reclami</HeroTitle>
                <HeroCaption marginBottom="none">
                    <strong>Saturno Assicurazioni</strong> è qui per ascoltarti
                </HeroCaption>
            </HeroContent>
        </HeroContainer>
        <Container
            marginBottom={{ mobile: '3xl', tablet: 'l', desktop: 'none' }}
            paddingBottom="3xl"
            paddingX={{ mobile: 'm', desktop: 'l' }}
        >
            <Box
                lineHeight="xl"
                width={{ mobile: 'full', desktop: '4/5' }}
                marginTop="l"
                paddingTop={{ mobile: 'l', tablet: '3xl' }}
            >
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight}>
                    Ti ricordiamo che, prima di inoltrare un reclamo, per chiarimenti e spiegazioni è sempre preferibile
                    contattare i nostri consulenti assicurativi al numero{' '}
                    <strong>
                        <u>
                            <AppLink href="tel:+3902465488700">02 465 488 700</AppLink>
                        </u>
                    </strong>{' '}
                    oppure mandare una mail a{' '}
                    <strong>
                        <u>
                            <AppLink href="mailto:reclami@saturno.it">reclami@saturno.it</AppLink>
                        </u>
                    </strong>
                    .
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight} marginBottom="m">
                    Un operatore sarà a tua disposizione dal lunedì al venerdì: 09:00 / 13:00 - 14:00 / 18:00 (festivi e
                    7 dicembre esclusi).
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight} marginBottom="m">
                    Se desideri inoltrare un reclamo in merito alla nostra attività oppure a quella dei nostri
                    collaboratori, puoi rivolgerti a Brokerhero s.r.l. con socio unico con le seguenti modalità:
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight}>
                    <Box component="span" display="block">
                        A mezzo posta all&apos;indirizzo: Largo Richini 6, 20122, Milano (MI)
                    </Box>
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight} marginBottom="m">
                    A mezzo email all&apos;indirizzo:{' '}
                    <strong>
                        <u>
                            <AppLink href="mailto:reclami@saturno.it">reclami@saturno.it</AppLink>
                        </u>
                    </strong>
                    .
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight} marginBottom="m">
                    <TextPreset preset="label-xl" className={styles.specialLineHeight} display="block">
                        Il reclamo dovrà contenere:
                    </TextPreset>
                    nome, cognome, domicilio e recapito telefonico del reclamante numero della polizza e nominativo del
                    contraente e/o numero del sinistro e data di accadimento breve descrizione del motivo della
                    lamentela ogni documento utile a descrivere il fatto e le relative circostanze.
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight} marginBottom="m">
                    La compagnia provvederà a fornire una risposta formale entro 45 giorni dalla ricezione del reclamo.
                    In caso di mancata risposta nel termine massimo di 45 giorni o nel caso di risposta insoddisfacente,
                    il cliente avrà la facoltà di inoltrar il reclamo direttamente all&apos;IVASS. L&apos;indirizzo
                    presso cui inviare il reclamo IVASS è: via del Quirinale, 21 - 00187 Roma.
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight}>
                    Il reclamo all&apos;IVASS dovrà contenere, oltre alle informazioni sopra elencate, anche la copia
                    del reclamo precedentemente inoltrato a Brokerhero s.r.l. con socio unico e/o Wakam S.A. e il loro
                    relativo riscontro. Per la risoluzione delle liti transfrontaliere è possibile presentare reclamo
                    all&apos;IVASS o al sistema estero competente, individuabile accedendo al sito{' '}
                    <strong>
                        <u>
                            <AppLink target="_blank" href="http://www.ec.europa.eu/fin-net">
                                http://www.ec.europa.eu/fin-net
                            </AppLink>
                        </u>
                    </strong>{' '}
                    chiedendo l&apos;attivazione della procedura FIN-NET.
                </TextPreset>
                <TextPreset preset="paragraph-xl" className={styles.specialLineHeight}>
                    Per le controversie relative alla quantificazione del danno e all&apos;attribuzione di
                    responsabilità permane la competenza esclusiva dell&apos;Autorità Giudiziaria, oltre alla facoltà di
                    ricorrere a sistemi conciliativi, ove esistenti.
                </TextPreset>
            </Box>
        </Container>
    </>
)

export default ServizioReclami
